import { render, staticRenderFns } from "./courseResource.vue?vue&type=template&id=d5849bf4&scoped=true&"
import script from "./qualityCouresCreate.js?vue&type=script&lang=js&"
export * from "./qualityCouresCreate.js?vue&type=script&lang=js&"
import style0 from "./courseResource.vue?vue&type=style&index=0&id=d5849bf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5849bf4",
  null
  
)

export default component.exports